<section>
  <div class="improve-box">
    <div class="container">
      <h2>{{"lookingFor.title" | translate}}</h2>
      <p>{{"lookingFor.note" | translate}}</p>
      <button mat-button="outlined" class="outlined mt-15" (click)="onContactClicked()">{{"global.getInTouch" | translate}}</button>
    </div>
  </div>
</section>
